import { useCallback } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';
import { FIELD_KEYS } from './externalPersonnelColumns';

/** Texts of Harici Personel Yönetimi (`externalPersonnel.*`); stored values stay as typed. */
const useExternalPersonnelText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`externalPersonnel.${key}`, vars), [t]);
  const fieldLabel = useCallback((field) => t(`externalPersonnel.fields.${FIELD_KEYS[field]}`), [t]);
  const statusLabel = useCallback((status) => (status ? t(`externalPersonnel.status.${status}`) : '-'), [t]);
  return { t, language, locale, label, fieldLabel, statusLabel };
};

export default useExternalPersonnelText;
